import { render } from "./ChatWindow.vue?vue&type=template&id=1f1b2a08"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=1f1b2a08&lang=css"

import exportComponent from "/Users/kate/Documents/Home/live-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__